import styles from "./SubmenuSeparator.module.css";

export const SubmenuSeparator = () => <div aria-hidden className={styles.separator} />;
